<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                        <strong>Serviceable Pincode</strong>
                        <div class="card-header-actions">
                            <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" data-toggle="tooltip" title="Refresh"  type="button"><i class="fa fa-refresh"></i></button>
                        </div>
                    </div>

                    <div>
                        <b-row>
                            <b-col md="5" v-if="user_type==1">
                                <b-row>
                                    <b-col md="4">
                                        <label><b>Upload CSV File</b></label>&nbsp;<span style="color: red;">*</span>
                                    </b-col>
                                    <b-col md="8">
                                        <b-form-group>
                                        <b-form-file
                                            type="file"
                                            v-model="pinfile"
                                            :state="Boolean(pinfile)"
                                            @change="uploadselect_file($event)"
                                            placeholder="Upload CSV File"
                                            accept=".csv"
                                        ></b-form-file>
                                        </b-form-group>
                        
                                        <div class="float-right">
                                        <a  href="img/serviceablepincodecsv.csv" download="serviceablepincodecsv.csv"
                                        target="_blank">Download Sample CSV</a>
                                        </div>
                                    
                                        <b-alert  variant="danger" dismissible fade :show="showmsgworng"  @dismissed="showmsgworng=false">
                                        File Uploading under process .Please Wait
                                        </b-alert>
                                    </b-col>
                                    </b-row>
                                </b-col>
                                
                                <b-col md="4" v-if="user_type==1">
                                    <b-button variant="primary" @click="uploadpinfile()">Upload</b-button>
                                    &nbsp;&nbsp;
                                    <b-button variant="success" data-toggle="tooltip" title="Serviceble Pincode" @click="opnmodelpincodeDetails()" v-if="is_serviceablePincode=='Yes'">
                                        Pincode
                                    </b-button> 
                                </b-col>
                        </b-row>
                    </div>

                    <div>
                        <b-col sm="12" class="text-right">
                            <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
                        </b-col>
             
                        <b-col md="12">
                            <b-table show-empty responsive :items="Items" :busy="isBusy" :fields="fields" :filter="filter" :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"  :bordered="bordered"  id="my-tableplan" :per-page="perPageplan"
                             :current-page="currentPageplan"> 
             
                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div> 
                                <template slot="createddate" slot-scope="row">
                                    <div>
                                        {{ row.item.createddate | ConvertTime12hour() }}
                                    </div>
                                </template>
                                
                                <template slot="file_url" slot-scope="row">
                                    <div>
                                        <a :href="row.item.file_url" target="_blank">
                                            <i
                                                class="fa fa-download"
                                                aria-hidden="true"
                                                v-b-tooltip.hover
                                                title="Click to download"
                                                style="font-size:20px;"
                                            ></i>
                                         </a>
                                    </div>
                                </template>

                                <template slot="is_done" slot-scope="row">
                                    <div>
                                        {{row.item.is_done===0?'No':'Yes'}}
                                    </div>
                                </template>
                                
                            </b-table>
                        </b-col>
                        <paginate 
                                :page-count="noofpages"
                                :page-range="10"
                                :margin-pages="2"
                                :click-handler="clickCallback"
                                :prev-text="'Prev'"
                                :next-text="'Next'"
                                :container-class="'pagination'"
                                :page-class="'page-item'">
                        </paginate>
                    </div>


                    <b-modal size="xl" title="Serviceble Pincode Details" v-model="serviceblepinDetails" @ok="serviceblepinDetails=false" hide-footer>

                        <b-col sm="12" class="text-right">
                          <a :href="loadurl">
                          <b-button variant="primary" @click="downlaodloadurl" :disabled="pintotalRows==0">Download</b-button></a>
                          <p > <b>Total Records :<span style="color:red;">{{pintotalRows}}</span></b> </p>
                       </b-col>
                       <b-row>
                        <b-col md="12">
                          <b-table show-empty responsive   :items="pinItems" :busy="isBusypin" :fields="pinfields" :current-page="pincurrentPage"  :per-page="pinperPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 
          
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div> 
                            <template slot="isactive" slot-scope="row">
                                <div>
                                    {{ row.item.isactive==1 ?'Yes':'No' }}
                                </div>
                            </template>
                            <template slot="createddate" slot-scope="row">
                                <div>
                                    {{ row.item.createddate | ConvertTime12hour() }}
                                </div>
                            </template>
                          </b-table>
                         </b-col>
                        </b-row>
                        <b-row>
                          <b-col v-if="pintotalRows>20">
                            <paginate 
                            :page-count="pinnoofpages"
                            :page-range="10"
                            :margin-pages="2"
                            :click-handler="pinclickCallback"
                            :prev-text="'Prev'"
                            :next-text="'Next'"
                            :container-class="'pagination'"
                            :page-class="'page-item'">
                            </paginate>
                      
                          </b-col> 
                        </b-row>
                      </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
 import CONSTANTS from '@/utils/constants'
  import Utils from '@/utils'
  import Vue from 'vue'
export default {
    data() {
        return {
            isBusy:false,
            Items :[],
            totalRows :0,
            fields:[
                { key: 'id', label: 'Sr.No', sortable: true},
                { key: 'created_by', label: 'Created By', sortable: true},
                { key: 'createddate', label: 'Created Date', sortable: true},
                { key: 'file_url', label: 'Download', sortable: true},
                { key: 'is_done', label: 'Is Data Synced'}
            ],

            pinfile :'',
            select_pinFiletype :'',
            selectpinFile :'',
            serviceblepinDetails : false,
            isBusypin : false,
            is_hubmapflag : 'No',
            pinItems :[],
            pinfields :[
            { key: 'hub_id', label: 'HUB ID', sortable: true},
            { key: 'hub_code', label: 'HUB Code', sortable: true},
            { key: 'admin_id', label: 'Admin Id', sortable: true},
            { key: 'destination_pincode', label: 'Destination Pincode', sortable: true},
            { key: 'isactive', label: 'IS Active', sortable: true},
            { key: 'created_by', label: 'Uploaded By', sortable: true}, 
            { key: 'createddate', label: 'Created Date', sortable: true},
            
            
            ],
            pintotalRows :0,
            pinnoofpages : '',
            pinpageNum :1,
            pinlistingpageno :1,
            pincurrentPage: 1,
            pinperPage: 20,
            loadurl :'',
            showmsgworng : false,
            mycollapse : false,
            user_type:null,
            noofpages:'',
            pageNum:1,
            listingpageno:1,

            //
            is_serviceablePincode:'No'
        }
    },
    created: function() { 
      var userdata = localStorage.getItem("userData");
         var userInfo = JSON.parse(userdata);
      // console.log("userInfo",userInfo)
      this.user_type=userInfo.user_type;
      this.pincodecsvList(this.pageNum)
    },

    methods: {

        refresh(){
            this.pincodecsvList(this.pageNum);
        },

        clickCallback (pageNum){
            this.listingpageno = pageNum;
            this.pincodecsvList(pageNum);
        },

        pincodecsvList(pageno,value){
            console.log("value",value)
            // let checkLength=[]
            this.isBusy=true;
            const obj={
                page_no:`${pageno}`
            }
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/uploadedServiceablePincodeCsvList`,obj).then(result => {
            this.isBusy=false;
            console.log("result",result)
            if (result.body.returnmsg === "Successful") {
                this.Items=result.body.returnvalue;
                this.totalRows=result.body.totalcount;
                this.noofpages=parseInt(this.totalRows)/20;
                this.noofpages=Math.ceil( this.noofpages);

                this.is_serviceablePincode = result.body.is_serviceablePincode

                if (value=='upload' && this.is_serviceablePincode=='No') {
                    this.showmsgworng=true
                }
                else{
                    this.showmsgworng=false
                }
                // this.Items.forEach(map => {
                //     if (map.is_hubmap == 'Yes') {
                //         checkLength.push(map.is_hubmap);
                //     } 
                // });
                //    console.log("checkLength",checkLength,checkLength.length)

                // this.showmsgworng=true
                   
                // if(checkLength.length>0){
                //     this.is_hubmapflag='Yes'
                //     this.showmsgworng=false
                //    }else{
                //     this.is_hubmapflag='No'
                //     this.showmsgworng=true
                //    }
            }else{
                this.Items=[];
                this.totalRows=0;
            }
            }).catch(ex => {
            console.log("error", ex);
            });
        },

        uploadselect_file(event) {
            this.selectpinFile = event.target.files[0];

            this.select_pinFiletype = event.target.files[0].type;
        },
        
        uploadpinfile(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
        
            console.log(" this.showmsgworng", this.showmsgworng)
            document.getElementById("overlay").style.display = "block";
            if (this.selectpinFile=="") {
                this.$fire({
                text:"Please Upload CSV File",
                type: "error",
                timer: 30000
                }); 
                document.getElementById("overlay").style.display = "none";
                return false;
            }
            if(this.select_pinFiletype == 'text/csv'){
            let data = new FormData();
            
            data.append('file', this.selectpinFile)
            data.append('uploaded_by', `${userInfo.sysemailid}`)
            let config = {
                header : {
                'Content-Type' : 'multipart/form-data'
                }
            }
            console.log("Config",config);
                // return false;
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/uploadHubServiceAblePincode`,
                data,{ header : {
                    'Content-Type' : 'multipart/form-data'
                }
                }).then(result => {
                console.log("--------------------------",result)
                document.getElementById("overlay").style.display = "none";
                    if (result.body.returnmsg === 'Successful') {      
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "success",
                        timer: 30000
                    });
                    this.selectpinFile='';
                    this.select_pinFiletype='';
                    this.pinfile='';
                    this.pincodecsvList(this.pageNum,'upload')
                    }
                    else{
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "error",
                        timer: 30000
                    }); 
                    }

                }).catch(ex => {
                console.log("error", ex);
                });
            }else{
            document.getElementById("overlay").style.display = "none";
                this.$fire({
                text:"Please Upload CSV File Only",
                type: "error",
                timer: 30000
                }); 
            }
        },

        opnmodelpincodeDetails(){
            this.serviceblepinDetails=true;
            this.pincodeDetails(this.pinpageNum);
        },
        pinclickCallback(pinpageNum){
            this.pinlistingpageno = pinpageNum;
            this.pincodeDetails(pinpageNum);
        },

        pincodeDetails(pagenum){
            this.pinItems=[]
            this.isBusypin=true;
        
            const obj={
                page_no:`${pagenum}`
            }
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getServiceablePincodeListing`,obj).then(result => {
            this.isBusypin=false;
            console.log("result",result)
            if (result.body.returnmsg === "Successful") {
                this.pinItems=result.body.returnvalue;
                this.pintotalRows=result.body.totalcount;
                this.pinnoofpages=parseInt(this.pintotalRows)/20;
                this.pinnoofpages=Math.ceil( this.pinnoofpages);
            }else{
                this.pinItems=[];
                this.pintotalRows=0;
            }
            }).catch(ex => {
            console.log("error", ex);
            });
        },

        downlaodloadurl(){
            this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getServiceablePincodeCsv`
        }
    },
}
</script>